// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"856":"4baabe27","1267":"5b5d4453","4723":"42235961"}[chunkId] + ".chunk.css";
};